import { atom } from 'jotai';

export const showExtraFacetsAtom = atom(null);
